const carouselItems = [
  {
    title: '2026科幻电影新纪元',
    desc: '国产科幻从跟跑到领跑，多部重磅作品构建全新宇宙观，视觉特效达到国际一线水准，故事深度与人文关怀并重。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20futuristic%20sci-fi%20cityscape%20at%20night%20with%20neon%20reflections%20on%20wet%20streets%2C%20cyberpunk%20aesthetic%2C%20cinematic%20wide%20shot%2C%20deep%20blues%20and%20warm%20orange%20accents%2C%20film%20grain%2C%20movie%20poster%20style%2C%20dramatic%20lighting&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '悬疑片年度口碑黑马',
    desc: '小成本大惊喜，多重反转让观众大呼过瘾。精妙的叙事结构和克制的表演，成就今年最值得讨论的悬疑佳作。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20venetian%20blind%20shadows%2C%20vintage%20desk%20lamp%2C%20scattered%20photographs%2C%20film%20noir%20atmosphere%2C%20deep%20browns%20and%20warm%20amber%20light%2C%20cinematic%20production%20design%2C%20moody%20composition&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '经典修复重返大银幕',
    desc: '一批影史经典经过4K数字修复后重新与观众见面，画质焕然一新，让新一代影迷也能感受黄金时代的银幕魅力。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20vintage%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20architectural%20details%2C%20art%20deco%20style%2C%20warm%20nostalgic%20lighting%2C%20empty%20stage%20with%20dramatic%20spotlight%2C%20cinematic%20atmosphere%2C%20rich%20textures&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '国漫电影工业化新高度',
    desc: '国产动画电影在技术和叙事上双双突破，精美画风融合东方美学，故事内核打动人心，票房与口碑双丰收。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20complex%20in%20misty%20mountains%2C%20golden%20hour%20lighting%2C%20epic%20scale%2C%20cinematic%20composition%2C%20traditional%20architecture%20with%20flowing%20silk%20elements%2C%20warm%20amber%20and%20jade%20tones%2C%20animated%20film%20aesthetic&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    title: '暑期档黑马频出',
    desc: '今年暑期档竞争激烈，多部中等体量影片凭借过硬质量和精准营销实现票房逆袭，为电影市场注入新活力。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20sunset%20sky%20over%20city%20skyline%20with%20warm%20golden%20clouds%2C%20cinematic%20wide%20angle%2C%20summer%20evening%20atmosphere%2C%20film%20texture%20overlay%2C%20movie%20poster%20aesthetic%2C%20hopeful%20and%20energetic%20mood%2C%20soft%20gradients&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">精选专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          深度策划的焦点专题，带你发现不容错过的精彩内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}